module.exports = __webpack_public_path__ + "img/nursery2.6bf59e19.jpg";